<template>
  <div id="app">
    <loading ref="loading"/>

    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"/>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Loading from './Loading'
import i18n from '~/plugins/i18n'
import store from '~/store'

// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    return components
  }, {})

export default {
  el: '#app',

  components: {
    Loading
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default'
  }),

  async beforeCreate () {
    // Preload data.
    await this.$store.dispatch('evaluations/fetchEvaluations')
    await this.$store.dispatch('isco/fetchISCO')
    await this.$store.dispatch('roles/fetchRoles')
    await this.$store.dispatch('languages/fetchLanguages')
    await this.$store.dispatch('nationalities/fetchNationalities')
  },

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  mounted () {
    this.$loading = this.$refs.loading
  },

  methods: {
    /**
    * Set the application layout.
    *
    * @param {String} layout
    */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/App.vue